import { AppConnection } from 'views/client/connections';
import { Help } from 'views/account/help';
import { OrganizationList } from 'views/firm/OrganizationList';
import { FirmUsers } from 'views/firm/account/firmUsers';
import { Billing } from 'views/firm/account/billing';
import { Upgrade } from 'views/firm/account/billing/upgrade';
import { Account } from 'views/profile';
import { Profile } from 'views/profile/profile';
import { Password } from 'views/profile/password';
import { TwoFA } from 'views/profile/2fa';

const Routes = [
  {
    path: '/help',
    view: Help,
    layout: 'firm',
    permission: 'user',
    title: 'Get Help'
  },
  {
    path: '/home',
    view: OrganizationList,
    layout: 'firm',
    permission: 'user',
    title: (user) => user?.is_firm ? 'Clients' : 'Companies'
  },
  {
    path: '/firm/apps',
    view: AppConnection,
    layout: 'firm',
    permission: 'user',
    title: 'Connections'
  },
  {
    path: '/firm/users',
    view: FirmUsers,
    layout: 'firm',
    permission: 'admin',
    title: 'Firm Users'
  },
  {
    path: '/firm/billing',
    view: Billing,
    layout: 'firm',
    permission: 'owner',
    title: 'Billing'
  },
  {
    path: '/firm/upgrade',
    view: Upgrade,
    layout: 'firm',
    permission: 'owner',
    title: 'Upgrade'
  },
  {
    path: '/firm/user/profile/index',
    view: Account,
    layout: 'firm',
    permission: 'user',
    title: 'Profile'
  },
  {
    path: '/firm/user/profile/profile',
    view: Profile,
    layout: 'firm',
    permission: 'user',
    title: 'Your Info'
  },
  {
    path: '/firm/user/profile/password',
    view: Password,
    layout: 'firm',
    permission: 'user',
    title: 'Change Password'
  },
  {
    path: '/firm/user/profile/mfa',
    view: TwoFA,
    layout: 'firm',
    permission: 'user',
    title: 'Manage MFA'
  }

]

export default Routes;
